import { render } from "./CommunityGallery.vue?vue&type=template&id=292e87fd&scoped=true"
import script from "./CommunityGallery.vue?vue&type=script&lang=js"
export * from "./CommunityGallery.vue?vue&type=script&lang=js"

import "./CommunityGallery.vue?vue&type=style&index=0&id=292e87fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292e87fd"]])

export default __exports__